export const createCheatsheetPage = () =>
  import("./CreateCheatsheetPage").then((m) => ({ Component: m.CreateCheatsheetPage }));
